import { LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface IndonesiaServiceCardProps {
  icon: LucideIcon;
  flag: string;
  title: string;
  subtitle: string;
  features: string[];
  color: 'red' | 'orange' | 'rose';
  onGetFreeAccess: () => void;
}

const IndonesiaServiceCard = ({ 
  icon: Icon, 
  flag, 
  title, 
  subtitle,
  features, 
  color,
  onGetFreeAccess 
}: IndonesiaServiceCardProps) => {
  const colorClasses = {
    red: 'from-red-500 to-red-700 hover:from-red-600 hover:to-red-800',
    orange: 'from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700',
    rose: 'from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700'
  };

  const borderClasses = {
    red: 'border-red-200 hover:border-red-300',
    orange: 'border-orange-200 hover:border-orange-300',
    rose: 'border-rose-200 hover:border-rose-300'
  };

  const iconBgClasses = {
    red: 'bg-red-100',
    orange: 'bg-orange-100',
    rose: 'bg-rose-100'
  };

  const iconColorClasses = {
    red: 'text-red-600',
    orange: 'text-orange-600',
    rose: 'text-rose-600'
  };

  return (
    <div className={`bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-xl border-2 ${borderClasses[color]} hover:shadow-2xl transition-all duration-300 transform hover:scale-105 animate-fade-in`}>
      <div className="flex items-center space-x-3 mb-4">
        <div className={`p-3 ${iconBgClasses[color]} rounded-xl`}>
          <Icon className={`w-8 h-8 ${iconColorClasses[color]}`} />
        </div>
        <span className="text-4xl">{flag}</span>
      </div>
      
      <h3 className="text-2xl font-bold text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-600 mb-4">{subtitle}</p>
      
      <ul className="space-y-3 mb-6">
        {features.map((feature, idx) => (
          <li key={idx} className="flex items-start space-x-2">
            <span className="text-red-600 mt-1">✓</span>
            <span className="text-gray-700 text-sm">{feature}</span>
          </li>
        ))}
      </ul>

      <div className="space-y-3">
        <Button 
          onClick={onGetFreeAccess}
          className={`w-full bg-gradient-to-r ${colorClasses[color]} text-white font-bold py-3 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105`}
        >
          Coba Gratis • Try Free
        </Button>
        
        <Button 
          onClick={() => window.location.href = '/consultation'}
          variant="outline"
          className="w-full border-2 border-red-600 text-red-600 hover:bg-red-50 font-bold py-3 rounded-xl transition-all duration-300"
        >
          Beli Sekarang • Purchase Now
        </Button>
      </div>
    </div>
  );
};

export default IndonesiaServiceCard;
